import { createSlice } from '@reduxjs/toolkit';
import {
  getGovernments,
  addGovernment,
  deleteGovernment,
  getGovernmentById,
  updateGovernment,
  filterGovernments,
} from './governmentsThunk';

const initialState = {
  governments: [],
  government: null,
  loading: false,
  error: null,
};

const governmentsSlice = createSlice({
  name: 'governments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGovernments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGovernments.fulfilled, (state, action) => {
        state.governments = action.payload;
        state.loading = false;
      })
      .addCase(getGovernments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addGovernment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addGovernment.fulfilled, (state, action) => {
        state.governments.push(action.payload);
        state.loading = false;
      })
      .addCase(addGovernment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteGovernment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGovernment.fulfilled, (state, action) => {
        state.governments = state.governments.filter(
          (government) => government.id !== action.payload
        );
        state.loading = false;
      })
      .addCase(deleteGovernment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getGovernmentById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGovernmentById.fulfilled, (state, action) => {
        state.government = action.payload;
        state.loading = false;
      })
      .addCase(getGovernmentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateGovernment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGovernment.fulfilled, (state, action) => {
        state.governments = state.governments.map((government) =>
          government.id === action.payload.id ? action.payload : government
        );
        state.loading = false;
      })
      .addCase(updateGovernment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(filterGovernments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(filterGovernments.fulfilled, (state, action) => {
        state.governments = action.payload;
        state.loading = false;
      })
      .addCase(filterGovernments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default governmentsSlice.reducer;
